// Named constants for signup route names used in route definitions,
// navigation calls, and the real-time listener guard.
export const SIGNUP_ROUTE_NAME = 'signup'
export const SIGNUP_INFO_ROUTE_NAME = 'signupInfo'
export const SIGNUP_SECURITY_ROUTE_NAME = 'signupSecurity'
export const SIGNUP_MATCH_ROUTE_NAME = 'signupMatch'
export const SIGNUP_MATCH_INFO_ROUTE_NAME = 'signupMatchInfo'
export const SIGNUP_INFO_EDIT_ROUTE_NAME = 'signupInfoEdit'
export const SIGNUP_COPARENT_INFO_EDIT_ROUTE_NAME = 'signupCoparentInfoEdit'
export const SIGNUP_CHILD_INFO_EDIT_ROUTE_NAME = 'signupChildInfoEdit'
export const SIGNUP_PASSWORD_EDIT_ROUTE_NAME = 'signupPasswordEdit'
export const SIGNUP_PHONE_EDIT_ROUTE_NAME = 'signupPhoneEdit'

/**
 * Route names where the prematch real-time listener should be active.
 */
export const PREMATCH_ROUTE_NAMES = Object.freeze([
  SIGNUP_MATCH_ROUTE_NAME,
  SIGNUP_MATCH_INFO_ROUTE_NAME
])
